<template>
  <ul class="nav-footer">
    <li>
      <p class="nav-footer-text">
        Follow Ylands and never miss any updates!
      </p>
    </li>
    <li id="navigation-icon-list">
      <a href="https://twitter.com/bohemiainteract" target="_blank">
        <TwitterPolyIcon />
      </a>
      <a
        href="https://www.youtube.com/channel/UC3NF7klLgt4sylAROJfSCtw"
        target="_blank"
      >
        <YouTubePolyIcon />
      </a>
      <a href="https://www.instagram.com/ylandsgame/">
        <InstagramPolyIcon />
      </a>
    </li>
    <li>
      <p id="nav-footer-UAPP">
        Users are advised to read the User Agreement &
        <a
          href="https://www.bistudio.com/privacy-policy"
          target="_blank"
          class="pp-link"
          >Privacy Policy.</a
        >
      </p>
    </li>
  </ul>
</template>
<script>
import TwitterPolyIcon from "../../assets/svg/twitter-polygon.svg?inline";
import YouTubePolyIcon from "../../assets/svg/youtube-polygon.svg?inline";
import InstagramPolyIcon from "../../assets/svg/instagram-polygon.svg?inline";

export default {
  name: "hamburger-footer",
  components: { TwitterPolyIcon, YouTubePolyIcon, InstagramPolyIcon }
};
</script>

<style scoped lang="scss">
.nav-footer {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: flex-end;

  li {
    list-style-type: none;
    p {
      font-size: 0.7857142857142857em;
      text-align: center;
      margin: 0 auto;
      flex-basis: 90%;
      padding: 0.8em;
      color: #dce3e9;
    }
    .nav-footer-text {
      font-weight: 700;
    }
    #nav-footer-UAPP {
      font-weight: 400;
      padding-top: 0.5em;
      font-family: "Palanquin", sans-serif;
      padding-bottom: 2em;

      .pp-link {
        padding: 0;
        text-decoration: underline;
        display: inline;
      }
    }
    a {
      svg {
        fill: #dce3e9;
      }
    }
  }

  #navigation-icon-list {
    justify-content: center;
    flex-direction: row;

    display: inline-flex;
    align-items: center;

    a {
      display: block;
      width: initial;
      padding: 0 0.2em 0 0.2em;

      svg:hover {
        fill: #ffa306;
      }
    }
  }

  @media (min-width: 551px) and (max-width: 980px) {
    li {
      p {
        font-size: 1.2em;
      }
    }
  }
}
</style>
